import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";

import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { getAllMeeting, getEntity, getEntityDetails, getMeetingByID, getTask, getTaskById, updateMeetingStatus } from "../../http/fundLync/entityAndAddress.helper";
import { decryptedValue, isPermission } from "common/utility";
import TableContainerV1 from "components/Common/TableContainerV1";
import { filter, isEmpty } from "lodash";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import ToastDialog from "components/Common/ToastDialog";

const TableActionsComponent = (props, entityType) => {
  const navigate = useNavigate();
  const user = decryptedValue(localStorage.getItem("user"));
  
  const navigateToEditRoles = (id) => {
    const encryptedId = btoa(id.toString());
      navigate(
        `/update-meeting/${encodeURIComponent(
          encryptedId
        )}`
      );
  };

  const navigateToDetails = (id) => {
    const encryptedId = btoa(id.toString());
      navigate(
        `/view-meeting-details/${encodeURIComponent(
          encryptedId
        )}`
      );
  };
  


  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end">
            <DropdownItem
            onClick={() => {
                navigateToEditRoles(props.id);
            }}
            >
            <i
                className="mdi mdi-pencil font-size-16 text-success me-1"
                id="edittooltip"
            ></i>
            Edit
            <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
            </UncontrolledTooltip>
            </DropdownItem>
            
            <DropdownItem
                onClick={() => {
                 navigateToDetails(props.id);
                }}
            >
                <i
                className="mdi mdi-eye font-size-16 text-success me-1"
                id="viewTooltip"
                ></i>
                View
                <UncontrolledTooltip placement="top" target="viewTooltip">
                  View
                </UncontrolledTooltip>
            </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const MeetingTable = (props) => {
  document.title = "Meeting Table | Fundlync";

  const navigate = useNavigate();
  const [meetingList, setMeetingList] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [isNewEntityPermission, setIsNewEntityPermission] = useState(false);
  const userObj = decryptedValue(localStorage.getItem("user")) || {};
  const { entityType } = userObj || "";
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  });
  const [isStatusModal, setIsStatusModal] = useState(false);
  const [entityStatusBucketList, setEntityStatusBucketList] = useState([]);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [filterValue, setFilterValue] = useState([]);
  const urlParams = new URLSearchParams(window.location.search);
  const filterType = urlParams.get("filter");

  const statusColors = {
    "Scheduled": "#3a99db", // blue
    "Conducted": "#34c38f", // green
    "Missed": "#ffc107", // yellow
    "Cancelled": "#f46a6a", // red
  };

  const capitalizeFirstLetter = (inputString) => {
    if (typeof inputString !== "string" || inputString.length === 0) {
      return inputString;
    }
    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
  };

  let handleChange;
  let handleChangeDeal;

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: true,
        Cell: (cellProps) => {
          handleChange = () => {
            navigateToEditEntity(cellProps.value)
          }
          handleChangeDeal = () => {
            navigateToDeal(cellProps.value)
          }
          return cellProps.value || '';
        }
      },
      {
        Header: "Entity Name",
        accessor: "entityId",
        filterable: true,
        Cell: (cellProps) => {
          let rowData = cellProps?.row?.original?.entity
          return (
            <div onClick={handleChange}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ cursor: 'pointer', color: '#21aa47' ,width:'140px'}}
              title = {rowData?.entityName || ''}
            >
              {truncateText(rowData?.entityName,15) || ''}
            </div>
          );
        }
      },
      {
        Header: "Deal Name",
        accessor: "dealId",
        filterable: true,
        Cell: (cellProps) => {
          let rowData = cellProps?.row?.original?.deal
          return (
            <div onClick={handleChangeDeal}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ cursor: 'pointer', color: '#21aa47', width: '140px' }}
            title={rowData?.dealName || ''}
          >
            {truncateText(rowData?.dealName, 15) || ''}
          </div>
          );
        }
      },
      {
        Header: "Meeting Title",
        accessor: "title",
        filterable: true,
        Cell: (cellProps) => {
          return (
            <div
              style={{width:'200px'}}
              title = {cellProps.value || ''}
            >
             { cellProps.value || ""}
            </div>
          );
        },
      },
      // {
      //   Header: "Meeting Date",
      //   accessor: "date",
      //   filterable: true,
      //   Cell: (cellProps) => {
      //     return cellProps.value || "";
      //   },
      // },
      {
        Header: "Date & Time",
        accessor: "date", 
        filterable: true,
        Cell: (cellProps) => {
          const row = cellProps.row.original;
          const date = row.date || "";
          const startTime = row.startTime || "";
          return (
            <div
              style={{width:'150px'}}
              title = {cellProps.value || ''}
            >
             { `${date}, ${startTime}` }
            </div>
          );
          // return `${date}, ${startTime}`;
        },
      },
      // {
      //   Header: "End Time",
      //   accessor: "endTime",
      //   filterable: true,
      //   Cell: (cellProps) => {
      //     return cellProps.value || "";
      //   },
      // },
      {
        Header: "Created By",
        FullName: "",
        accessor:"createdByUser",
        filterable: true,
        hideOrder: 4,
        Cell: (cellProps) => {
          
          const rowData = cellProps.row.original;
          let name = "";
            if (rowData.createdByUser?.firstName) {
              name +=
                capitalizeFirstLetter(rowData.createdByUser?.firstName) +
                " ";
            }
            if (rowData.createdByUser?.lastName) {
              name +=
                capitalizeFirstLetter(rowData.createdByUser?.lastName) +
                " ";
            }
          return name;
        },
      },
      {
        Header: "Location",
        accessor: "location",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      // {
      //   Header: "invitees",
      //   accessor: "invitees",
      //   filterable: true,
      //   Cell: (cellProps) => {
      //     return cellProps.value || "";
      //   },
      // },
      {
        Header: "Status",
        accessor: "meetingStatus",
        filterable: true,
        Cell: (cellProps) => {
          let rowData = cellProps?.row?.original
          const status = cellProps.value || "";
          const color = statusColors[status] || "#6c757d";
          return (
            <span onClick={()=>{handleStatusChange(rowData)}}
              // onMouseEnter={handleMouseEnter}
              // onMouseLeave={handleMouseLeave}
              style={{
                cursor: 'pointer',
                color: color, 
                width: '110px',
                fontWeight: '600',
                padding: '5px 15px', 
                borderRadius: '20px',
                border: `2px solid ${color}`,
                display: 'inline-block', 
                textAlign: 'center', 
                lineHeight: 'normal',
              }}
            >
              {rowData?.meetingStatus || ''}
            </span>
          );
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(rowData, entityType);
        },
      },
    ],
    []
  );

  const validation = useFormik({
    initialValues: {
      id: "",
      meetingStatus: "",
    },
    validationSchema: Yup.object({
      meetingStatus: Yup.string().required("Please select Meeting Status"),
    }),
    onSubmit: (values) => {
      const data = {
        id: values.id,
        meetingStatus: values.meetingStatus,
      }
      updateMeetingStatus(data).then((response)=>{
        if(response && response.status){
          setToastInfo({
            message: response.message,
            showToast: true,
            role: "success",
          })
        handlePageChange(pagination.pageIndex || 1, pageSize, searchValue, columnId, sortingOrderStatus);
        }else{
          setToastInfo({
            message: response.message || 'Something went wrong!',
            showToast: true,
            role: "error",
          })
        }
        validation.resetForm()
        setIsStatusModal(false)
      }).catch((error)=>{
        setIsStatusModal(false)
        setToastInfo({
          message: 'Something went wrong!',
          showToast: true,
          role: "error",
        })
      })
    },
    });
  
    const handleStatusChange = (data) => {
    validation.setFieldValue('id', data.id)
    validation.setFieldValue('meetingStatus', data?.meetingStatus)
    getDropDownList({ dropdownName: "Meeting_Status" })
      .then((response) => {
        if (response.status) {
          const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "Meeting_Status")?.dropdownValues || []
          const modifiedDropdownValues = dropdownValues.map(dv => ({
            label: dv.displayName,
            value: dv.dropdownValue
          }));
          setEntityStatusBucketList(modifiedDropdownValues)
          setIsStatusModal(true)
        }
      }).catch((error) => {
        console.log(error);
      })
    };
    const convertTo12HourFormat = (time) => {
      let [hours, minutes] = time.split(':');
      hours = parseInt(hours, 10);
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // Convert to 12-hour format
      return `${hours}:${minutes} ${ampm}`;
   };

   const navigateToEditEntity = async (Id) => {
    try {
      const taskResponse = await getMeetingByID({ Id });
      const entityId = taskResponse.entityId;
      try {
        const entityDetailsResponse = await getEntityDetails({ entityId });
        const entityType = entityDetailsResponse.data.entity_type;
        const encryptedId = btoa(entityId.toString());
        if (entityType === 'Customer') {
          navigate(`/${userObj.roleName}/entity-Dashboard?id=${encodeURIComponent(encryptedId)}`);
        } else {
          navigate(`/${userObj.roleName}/financierDetails?id=${encodeURIComponent(encryptedId)}`);
        }
      } catch (entityError) {
        console.error('Error fetching entity details:', entityError);
      }
    } catch (dealError) {
      console.log('Error fetching entity details:', dealError)
    }
  };

  const navigateToDeal = async (Id) => {
    try {
      const dealInfoResponse = await getMeetingByID({ Id });
      const entityId = dealInfoResponse.dealId;
      try {
        const encryptedId = btoa(entityId.toString());
        navigate(`/${userObj.roleName}/viewDeal?id=${encodeURIComponent(encryptedId)}`);
      } catch (entityError) {
        console.error('Error fetching entity details:', entityError);
      }
    } catch (dealError) {
      console.log('Error fetching entity details:', dealError)
    }
  };

  const handleMouseEnter = (event) => {
    event.target.style.color = "#34c38f";
    event.target.style.textDecoration = 'underline';
  };
  const handleMouseLeave = (event) => {
    event.target.style.color = "#21aa47";
    event.target.style.textDecoration = 'none';
  };

  const truncateText = (text, charLimit) => {
    if (text && text.length > charLimit) {
        const truncated = text.substring(0, charLimit) + '...';
        return truncated;
    }
    return text;
};


   const user = decryptedValue(localStorage.getItem("user"));
  const getMeetingList = (data) => {
    getAllMeeting(data)
      .then((responseFromAPI) => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          const formattedMeetings = responseFromAPI.data.data.map(meeting => {
            return {
              ...meeting,
              date: formatDate(meeting.date),
              startTime: convertTo12HourFormat(meeting.startTime),
              endTime: convertTo12HourFormat(meeting.endTime) 
            };
          });
           setMeetingList(formattedMeetings);
           validation.setFieldValue('meetingStatus', )
          const { totalItems, totalPages, currentPage } = responseFromAPI.data;
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          });
        } else {
          setMeetingList([]);
          setPagination({
            pageIndex: 0,
            pageCount: 0,
            totalRecords: 0,
          });
        }
      })
      .catch((error) => {});
  };

  const handlePageChange = (
    page,
    pageSize,
    searchKey = searchValue,
    columnName = columnId,
    sortingOrder = sortingOrderStatus,
    filter =filterValue,
  ) => {
    setPageSize(pageSize);
    if (filterType) {
        getMeetingList({
        page,
        limit: pageSize,
        searchKey,
        columnName,
        sortingOrder,
        filterType,
        user,
        filter
      });
    } 
    else {
        getMeetingList({
        page,
        limit: pageSize,
        searchKey,
        columnName,
        sortingOrder,
        user,
        filter
      });
    }
  };

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
  };

  let debounceTimeout;
  const handleSearchFilter = (value, pageSize) => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      if (filterType) {
        if (value) {
          setSearchValue(value);
          handlePageChange(1, pageSize, value, columnId, sortingOrderStatus, filterValue, filterType);
        } else {
          setSearchValue('');
          handlePageChange(1, pageSize, '', columnId, sortingOrderStatus, filterValue, filterType);
        }
      } else {
        setSearchValue(value);
        handlePageChange(1, pageSize, value, columnId, sortingOrderStatus, filterValue);
      }
    }, 500);
  };
  const handleClearSearch = () => {
    
    if (filterType) {
      setFilterValue([])
      handlePageChange(1, pageSize, "", columnId, sortingOrderStatus, [], filterType);
    } else {
      setSearchValue("");
      setFilterValue([]);

      handlePageChange(1, pageSize, "", columnId, sortingOrderStatus,  []);
    }
  };

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("selectedFilters_meetings_tab_1"))
    setFilterValue(data || [])
    if(data?.length > 0 && !filterType){
      getMeetingList({ user, filter:data })
    }else if (filterType) {
        getMeetingList({ filterType, user: userObj , filter:filterValue});
    }else {
        getMeetingList({user});
    }
    checkPermissions();
  }, []);

  const checkPermissions = async () => {
    const isNewEntitypermission = await isPermission(
      "apiConfiguration",
      "create_permission"
    );
    setIsNewEntityPermission(isNewEntitypermission);
  };

  const handleCustomerClicks = () => {
    navigate(`/${userObj.roleName}/schedule-meeting`);
  };

  const buttonSection = (
    <div className="text-sm-end">
        <Button
          type="button"
          style={{ backgroundColor: '#21aa47', borderColor: '#21aa47' }}
          className="btn-rounded mb-2 me-2"
          onClick={handleCustomerClicks}
        >
          <i className="mdi mdi-plus me-1" />
          {"New Meeting"}
        </Button>
    </div>
  );

  // Format date
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();
    

    return `${day}-${month}-${year}`;
  }
  const handleFilter = (newFilterValue, newPageSize) => {
    setSearchValue("")
    setFilterValue(newFilterValue);
    setPageSize(newPageSize);
    handlePageChange(1, newPageSize, "", columnId, sortingOrderStatus, newFilterValue);
  };
  return (
    <React.Fragment>
    <div className="page-content">
        <Container fluid>
        <Breadcrumbs title="Meeting List" />
            <Row className="vertical-scroll">
                <Col xs="12">
                <Card>
                    <CardBody>
                    <TableContainerV1
                    tabIndex={1}
                        columns={columns}
                        data={meetingList}
                        pagination={pagination}
                        handlePageChange={handlePageChange}
                        handleSearchFilter={handleSearchFilter}
                        customSection={buttonSection}
                        sortOptions={sortingOptions}
                        handleSortColumn={handleSortColumn}
                        handleClearSearch={handleClearSearch}
                        className="custom-header-css"
                        tableFor="meeting"
                        handleFilter={handleFilter}
                        activeTab={1}
                    />
                    </CardBody>
                </Card>
                </Col>
            </Row>
            <ToastDialog
            message={toastInfo.message || ""}
            showToast={toastInfo.showToast}
            role={toastInfo.role}
            onCloseFn={() => setToastInfo({ showToast: false })}
          ></ToastDialog>

          <Modal
            isOpen={isStatusModal}
            role="dialog"
            autoFocus={true}
            centered
            data-toggle="modal"
            toggle={() => {
              setIsStatusModal(!isStatusModal);
            }}
          >
            <div>
              <ModalHeader
                className="border-bottom-0"
                toggle={() => {
                  setIsStatusModal(!isStatusModal);
                }}
              ></ModalHeader>
            </div>
            <div className="modal-body">
              <div className="text-center mb-4">
                <div className="row justify-content-center">
                  <div className="col-xl-10">
                    <h4 className="text-success">Select Meeting Status</h4>
                    <Form
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <Col xl={12} >
                        <Input
                          name="meetingStatus"
                          type="select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.meetingStatus}
                          invalid={validation.touched.meetingStatus && !!validation.errors.meetingStatus}
                        >
                          <option value="" selected disabled>Select Meeting Status</option>
                          {entityStatusBucketList?.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}

                        </Input>
                        {validation.touched.meetingStatus && validation.errors.meetingStatus ? (
                          <FormFeedback type="invalid">
                            {validation.errors.meetingStatus}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Row>
                        <Col sm="12" >
                          <div className="d-flex gap-3 justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-success save-customer mt-2"
                            >
                              Submit
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </Container>
    </div>
</React.Fragment>
  );
};

export default MeetingTable;
